import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "name" }
const _hoisted_2 = { class: "emq-table-footer" }

import { getProfitSharingReport } from '@/api/operation'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import { pick } from 'lodash'
import CommonPagination from '@/components/commonPagination.vue'
import ReportingExport from './ReportingExport.vue'


import { defineComponent, ref, defineExpose, Ref } from 'vue'

const __default__ = defineComponent({
  name: 'ProfitBillView',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const { updateParams } = usePaginationRemember('operators-detail')
const visible = ref(false)
const loading = ref(false)
const billData = ref([])
const timeGrain = ref(10)
const walletId = ref('')
// const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()

const showDialog = ref(false)
const showInfo: Ref<undefined | Record<string, any>> = ref(undefined)
const exportReport = async (row: any) => {
  showDialog.value = true
  showInfo.value = row
}

const open = (id: string) => {
  walletId.value = id
  visible.value = true
  initPageMeta() // 重置分页信息
  loadData() //加载初始化表格数据
}

const loadData = async (_params = {}) => {
  loading.value = true
  const sendParams = {
    walletId: walletId.value,
    grain: timeGrain.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }
  try {
    const { list = [], pageReply = {} } = await getProfitSharingReport(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']) })
    billData.value = list
  } catch (error) {
    billData.value = []
    initPageMeta()
  } finally {
    loading.value = false
  }
}

const handleSearch = () => {
  loadData({ page: 1 })
}

const handleClose = (done: () => void) => {
  visible.value = false
  walletId.value = '' // 清空 walletId
  billData.value = [] // 清空账单数据
  initPageMeta() // 重置分页信息
  done() // 调用 done 方法关闭对话框
}

expose({
  open,
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _ctx.$t('Operation.reportInfo'),
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "70%",
    "z-index": 1999,
    "custom-class": "evse-drawer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "search-wrapper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('Base.timeGrain')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: timeGrain.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeGrain).value = $event)),
                placeholder: _ctx.$t('Operation.selectGrain')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('Base.day'),
                    value: 10
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('Base.month'),
                    value: 30
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('Base.year'),
                    value: 40
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: billData.value }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "time",
            label: _ctx.$t('Base.time'),
            width: "auto"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.id,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(row.time), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "walletName",
            label: _ctx.$t('Base.walletName'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "totalTradeAmount",
            label: _ctx.$t('Base.totalTradeAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "psTotalAmount",
            label: _ctx.$t('Base.psTotalAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "psServiceAmount",
            label: _ctx.$t('Base.psServiceAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "psElectricAmount",
            label: _ctx.$t('Base.psElectricAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "feeAmount",
            label: _ctx.$t('Order.feeAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "finalAmount",
            label: _ctx.$t('Order.finallyAmount'),
            width: "auto"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (exportReport(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.export')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'reportingExport']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(ReportingExport, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        info: showInfo.value
      }, null, 8, ["modelValue", "info"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})